import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/board-foot-calculator',
  component: () => import('../../routes/BoardFootCalculator.svelte'),
  card: {
    id: 'board-foot-calculator',
    title: 'Board Foot Calculator',
    description: 'Calculate board feet, cubic feet, and surface area of lumber. Essential for woodworkers, framers, and lumberyards.',
    icon: 'carpenter',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-700',
    href: '/board-foot-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Board Foot Calculator – Lumber Volume & Surface Area',
    description: 'Free board foot calculator. Calculate board feet, cubic feet, lineal feet, and surface area of lumber boards. Perfect for woodworking and construction projects.',
  },
};

export default meta;
